import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  // breakpoint: {
  //   thresholds: {
  //     xs: 360,
  //   },
  //   scrollbarWidth: 10,
  // },
  theme: {
    primary  : '#ee44aa',
    secondary: '#424242',
    accent   : '#82B1FF',
    info     : '#2196F3',
    success  : '#4CAF50',
    warning  : '#FFC107',
  },
  iconfont: 'md',
});
